import { withRedirectUnauthorized } from '../../feature/authority/utils/withAuthority';
import AdministratorManagement from '../../components/settings/administrator/AdministratorManagement';

const SettingsAdministratorPage = () => {
  return <AdministratorManagement />;
};

export default withRedirectUnauthorized('administratorManagement', SettingsAdministratorPage);
